export default __webpack_public_path__ + "static/profile-img03-2a155f7525fe087294eb71b3e12c5c58.png";